<app-navbar></app-navbar>
<div class="p-0">
    <div class="container-fluid m-0 p-0">
        <div class="row p-0 m-0 mb-3">
            <div class="col-md-12 p-0 m-0">
                <div class="row m-0 p-0">
                    <div class="col-12 p-0 m-0 col-md-12 text-center text-primary">
                        <h4 class="m-0 p-0 text-bold">ENTRADA DE CAMINHÕES / PORTARIA</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-0 p-0 px-2">
            <div class="col-md-12 p-0 m-0">
                <form id="addRegistro" class="m-0" action="#">
                    <div class="row m-0 p-0 mb-1">
                        <div class="col-2 p-0 pr-1 m-0">
                            <div class="form-group m-0"><label class="m-0">Placa</label>
                                <input (keyup)="moveNextField($event, 8, 'tipo')" (blur)="changeUppercase($event, 'placa'); getPlacaInfo($event)" [value]="veiculoPlaca" type="text" class="form-control text-uppercase" name="placa" maxlength="8" placeholder="ABC0000" autocomplete="off"
                                    required autofocus>
                            </div>
                        </div>
                        <div class="col-2 p-0 pr-1 m-0">
    <div class="form-group m-0">
        <label class="m-0">Tipo</label>
        <div class="select-wrapper">
            <select (change)="changeNextField($event, 'cpf')" class="form-control" name="tipo" required>
                <option value="" selected>Selecione...</option>
                <option value="Toco" [selected]="veiculoInfo.Tipo == 'Toco'">Toco</option>
                <option value="Truck" [selected]="veiculoInfo.Tipo == 'Truck'">Truck</option>
                <option value="Julieta" [selected]="veiculoInfo.Tipo == 'Julieta'">Julieta</option>
                <option value="Bitrem" [selected]="veiculoInfo.Tipo == 'Bitrem'">Bitrem</option>
                <option value="Vanderleia" [selected]="veiculoInfo.Tipo == 'Vanderleia'">Vanderleia</option>
                <option value="Carreta" [selected]="veiculoInfo.Tipo == 'Carreta'">Carreta</option>
            </select>
            <i class="fas fa-chevron-down select-arrow"></i>
        </div>
    </div>
</div>
                        <div class="col-2 p-0 pr-1 m-0">
                            <div class="form-group m-0"><label class="m-0">Condutor</label>
                                <input (keyup)="moveNextField($event, 14, 'condutor')" (blur)="getCondutorInfo($event)" type="tel" [value]="veiculoInfo.CPF" class="form-control cpfcondutor cpf" name="cpf" placeholder="000.000.000-00" autocomplete="off" required maxlength="14">
                            </div>
                        </div>
                        <div class="col-3 p-0 pr-1 m-0">
                            <div class="form-group m-0"><label class="m-0">&nbsp;</label>
                                <input (keyup)="moveNextField($event, 60, 'celular')" (blur)="changeUCName($event, 'condutor')" [value]="veiculoInfo.Condutor" type="text" class="form-control nomecondutor" name="condutor" placeholder="Fulano de Tal" autocomplete="off" required maxlength="60">
                            </div>
                        </div>
                        <div class="col-2 p-0 pr-1 m-0">
                            <div class="form-group m-0"><label class="m-0">Celular</label>
                                <input (keyup)="moveNextField($event, 16, 'submitregistro')" (blur)="changeCelular($event)" type="tel" [value]="veiculoInfo.Celular" class="form-control telefone" name="celular" placeholder="(62) 9 9898-8989" autocomplete="off" required>
                            </div>
                        </div>
                        <div class="col-1 p-0 m-0 d-flex justify-content-center align-items-end">
                            <div class="form-group m-0 p-0">
                                <button id="btnaddregistro" type="button" (click)="addRegistro()" [disabled]="exibeAguarde" name="submitregistro" class="btn btn-primary p-2 px-4">OK</button>
                            </div>
                        </div>
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-12 p-0 m-0 is-invalid-field" style="display: none;">
                            Campo obrigatório não preenchido!
                        </div>
                    </div>
                    <div class="row m-0 p-0 aguarde-autopreenchimento" *ngIf="exibeAguarde">
                        <div class="col-12 p-0 m-0">
                            <i class="fas fa-spinner fa-pulse"></i> Aguarde...
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="p-0 mt-0 px-2">
    <div class="container-fluid m-0 p-0">
        <div class="row m-0 p-0">
            <div class="col-md-12 m-0 p-0">
                <hr class="mb-1 m-0 p-0" />
                <div class="table-responsive">
                    <table class="table" id="tabFila">
                        <thead>
                            <tr>
                                <th style="width: 5%; text-align: center;font-weight: bold !important;">#</th>
                                <th style="width: 10%; text-align: center;font-weight: bold !important;">Placa</th>
                                <th style="width: 15%; text-align: center;font-weight: bold !important;">Tipo</th>
                                <th style="width: 25%; text-align: center;font-weight: bold !important;">Condutor</th>
                                <th style="width: 15%; text-align: center;font-weight: bold !important;">Celular</th>
                                <th style="width: 20%; text-align: center;font-weight: bold !important;">Data/Hora</th>
                                <th style="width: 10%; text-align: center;font-weight: bold !important;">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Os dados serão carregados via DataTables -->
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>